"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderUtilityMenus = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var ColumnMenu_1 = __importDefault(require("../Header/Helpers/ColumnMenu"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_1 = require("@ryerson/frontend.common");

var StaticItem_1 = __importDefault(require("../common/StaticItem"));

var Utils_1 = require("../Header/Helpers/Utils");

var StyledComponents_1 = require("./StyledComponents");

var router_1 = require("@reach/router");

var Constants_1 = require("../common/Constants");

var renderUtilityMenus = function renderUtilityMenus(language, location, country, theme, mobileBreakPoint, languageMenuItems, countryMenuItems, locationMenuData, openUtilMenu, setOpenUtilMenu, setLocalization, bodyBindClick, bodyUnbindClick, bodyClicked, headerSettings, storeDirectory) {
  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      primaryBrand = _theme$colors$primary.primaryBrand,
      lightGray = _theme$colors$primary.lightGray;
  var _headerSettings$utili = headerSettings.utilityMenus,
      showLanguage = _headerSettings$utili.showLanguage,
      showCountry = _headerSettings$utili.showCountry,
      showLocation = _headerSettings$utili.showLocation;
  return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: (0, StyledComponents_1.utilityNavMenuItem)(mobileBreakPoint),
      children: language && showLanguage && (0, jsx_runtime_1.jsx)(ColumnMenu_1.default, {
        breakPoint: mobileBreakPoint,
        width: 110,
        menuTop: 35,
        value: frontend_common_1.withTranslation[language][language],
        menuData: languageMenuItems,
        menuName: "language",
        textColor: lightGray,
        isExpanded: openUtilMenu === "language",
        dividerStyle: "caret",
        useValueTextDisplay: true,
        handleMenuItemClicked: function handleMenuItemClicked(menuName, val) {
          setLocalization(function (prev) {
            return Object.assign(Object.assign({}, prev), {
              language: val
            });
          });
          setOpenUtilMenu("");
          document && bodyUnbindClick(bodyClicked);
        },
        handleMenuOpen: function handleMenuOpen(menuName) {
          var alreadyOpen = openUtilMenu === "language";
          setOpenUtilMenu(alreadyOpen ? "" : menuName);
          document && bodyBindClick(bodyClicked);
        }
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: (0, StyledComponents_1.utilityNavMenuItem)(mobileBreakPoint),
      children: country && showCountry && (0, jsx_runtime_1.jsx)(ColumnMenu_1.default, {
        breakPoint: mobileBreakPoint,
        width: 150,
        menuTop: 35,
        value: frontend_common_1.withTranslation[country][language],
        menuData: countryMenuItems,
        textColor: lightGray,
        menuName: "country",
        dividerStyle: "caret",
        isExpanded: openUtilMenu === "country",
        useValueTextDisplay: true,
        handleMenuItemClicked: function handleMenuItemClicked(menuName, val) {
          val !== frontend_application_1.Country.cn && setLocalization(function (prev) {
            return Object.assign(Object.assign({}, prev), {
              country: val
            });
          });
          val === frontend_application_1.Country.cn && window.open(Constants_1.CHINA_URL, "_blank");
          setOpenUtilMenu("");
          document && bodyUnbindClick(bodyClicked);
        },
        handleMenuOpen: function handleMenuOpen(menuName) {
          var alreadyOpen = openUtilMenu === "country";
          setOpenUtilMenu(alreadyOpen ? "" : menuName);
          document && bodyBindClick(bodyClicked);
        }
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: (0, StyledComponents_1.utilityNavMenuItem)(mobileBreakPoint),
      children: locationMenuData && showLocation && (0, jsx_runtime_1.jsx)(ColumnMenu_1.default, {
        breakPoint: mobileBreakPoint,
        value: location,
        width: country === "us" && locationMenuData.items.length > 1 ? (0, Utils_1.getMenuWidth)(country, language) : 220,
        dividerStyle: "caret",
        menuTop: 35,
        disabled: !locationMenuData.active || country === frontend_application_1.Country.cn,
        menuText: locationMenuData.display,
        menuName: locationMenuData.name,
        menuData: locationMenuData.items,
        textColor: lightGray,
        isExpanded: openUtilMenu === locationMenuData.name,
        handleMenuItemClicked: function handleMenuItemClicked(menuName, val) {
          var url = "/locations/".concat(frontend_application_1.CountryUrl[country], "/").concat(val);
          storeDirectory === Constants_1.STORE ? (0, router_1.navigate)(url) : window.location.href = url;
          setOpenUtilMenu("");
          document && bodyUnbindClick(bodyClicked);
        },
        handleMenuOpen: function handleMenuOpen(menuName) {
          var isOpen = openUtilMenu === locationMenuData.name;
          setOpenUtilMenu(isOpen ? "" : menuName);
          document && bodyBindClick(bodyClicked);
        },
        columnFooter: function columnFooter(colIndex) {
          if (colIndex === locationMenuData.items.length - 1) {
            return (0, jsx_runtime_1.jsx)("span", {
              css: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t\t"])), location === frontend_application_1.Location.AllLocations && "color:".concat(primaryBrand, ";")),
              onClick: function onClick(e) {
                e.stopPropagation();
                setOpenUtilMenu(""); // TODO this navigate somewhere
                //setLocation(Location.AllLocations);
              },
              children: country !== frontend_application_1.Country.mx && (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                breakPoint: mobileBreakPoint,
                color: secondaryBrand,
                returnType: "external-link",
                itemName: "allLocations"
              })
            });
          } else {
            return null;
          }
        }
      })
    })]
  });
};

exports.renderUtilityMenus = renderUtilityMenus;